import React from 'react';
import MaterialIcon from '../../elements/MaterialIcon.jsx';

/**
 * An account's icon: a Material icon in white on a rounded square of the account's colour, the same
 * size as an institution's badge so the two line up in a card's title. Given a `logo` (an image url,
 * see logoForAccount()), that is drawn in the same square instead.
 */
export default function AccountIcon({ icon, color, size = 24, title = null, logo = null }) {
	if(logo) {
		return (
			<img
				className='account_icon account_icon_logo'
				style={{ width: size, height: size }}
				src={logo}
				alt=''
				title={title || undefined}
			/>
		);
	}
	return (
		<span
			className='account_icon'
			style={{ width: size, height: size, backgroundColor: color }}
			title={title || undefined}
		>
			<MaterialIcon style={{ fontSize: Math.round(size * 0.7) }}>{icon}</MaterialIcon>
		</span>
	);
}
